import React, {
    useState,
    Fragment,
    useCallback,
    Suspense,
    useEffect,
} from "react";
import {
    Card,
    CardBody,
    CardHeader,
    Form,
    FormGroup,
    Input,
    Media,
} from "reactstrap";
import { Breadcrumbs, Btn, H4 } from "../../../../AbstractElements";
// import  {PatientList} from '../../../../Data/Patient'
import DataTable from "react-data-table-component";
import { Navigator } from "../../../../Data/Table/Defaultdata";
import Loader from "../../../../Layout/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { DeletePatient, PatientList } from "../../../../apiController";
import { roleId } from "../../PageLayout/SimplePage";
import { userId } from "../../PageLayout/UpcomingSchedule";
import { roles_permissions } from "../../../../Layout/Sidebar/Menu";



const PatientView = () => {
    const navigate = useNavigate();
    const [searchKeyword, setSearchKeyword] = useState("");
    const handleSearchKeyword = (keyword) => {
        setSearchKeyword(keyword);
        // searchMember(keyword);
    };

    const clearSearchTab = () => {
        setSearchKeyword("");
    };

    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState();
    const [patient, setPatient] = useState([]);

    const permission = roles_permissions.find(module => module.module_name === 'Patient')

    // console.log("patient", patient);

    const handleRowSelected = useCallback((state) => {
        setSelectedRows(state.selectedRows);
    }, []);

    const PatientPage = ({ to, name, data }) => {
        const navigate = useNavigate();
        // console.log('returned')
        const handleNavigation = () => {
            navigate(to, { state: { data: data } });
            // navigate(`${to}/${action}`);
        };
        // return <Navigate exact to={`${process.env.PUBLIC_URL}/patientList`}  navigate(`${process.env.PUBLIC_URL}/patientList/:layout`)/>
        return (
            <div
                className="f-w-700 font-success"
                onClick={handleNavigation}
                style={{ cursor: "pointer" }}
            >
                {name}
            </div>
        );
    };

    const searchedPatients = patient
        .filter(
            (c) =>
                (c.patient_reg_no ?? "").includes(searchKeyword.toLowerCase()) ||
                (`${c.first_name} ${c.surname}`.toLowerCase() ?? "").includes(
                    searchKeyword.toLowerCase()
                ) ||
                (c.phone ?? "").includes(searchKeyword.toLowerCase()) ||
                c.gender?.toLowerCase() === searchKeyword.toLowerCase()
        )
        .reverse();


    console.log("searchedPatients", searchedPatients);

    const dummytabledata = searchedPatients.map((row, ind) => ({
        ind: ind + 1,
        id: row.id,
        name: (
            <Media body className="align-self-center">
                <PatientPage
                    to={`${process.env.PUBLIC_URL}/patientinfo/:layout`}
                    name={`${row.first_name} ${row.surname}`}
                    data={row}
                />
            </Media>
        ),
        date: row.created_at ? row.created_at?.split(" ")[0] : "-",
        regno: row.patient_reg_no,
        // designation: 'System Architect',
        contactnumber: (
            <span className="f-w-700">
                <i className="icofont"></i> {row.phone}
            </span>
        ),
        gender: row.gender,
        action: (
            <span>
                {" "}
                <Navigator
                    to={`${process.env.PUBLIC_URL}/patientForm/:layout`}
                    params={{ rowData: row, btn: "edit" }}
                />
                {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button', onClick: Navigator }}>Edit </Btn> */}
            </span>
        ),
        // budget: '$3142.00',
    }));

    console.log("dummytabledata", dummytabledata);

    const tableColumns = [
        {
            name: "#",
            selector: (row) => row["ind"],
            sortable: true,
            center: false,
        },
        {
            name: "Name",
            selector: (row) => row["name"],
            sortable: true,
            center: false,
        },
        {
            name: "Date",
            selector: (row) => `${row.date}`,
            sortable: true,
            center: true,
        },
        {
            name: "Reg No.",
            selector: (row) => `${row.regno}`,
            sortable: true,
            center: true,
        },
        {
            name: "Contact Number",
            selector: (row) => row["contactnumber"],
            sortable: true,
            center: true,
        },
        {
            name: "Gender",
            selector: (row) => `${row.gender}`,
            sortable: true,
            center: true,
        },
        // {
        //     name: "Action",
        //     selector: (row) => row["action"],
        //     sortable: false,
        //     center: true,
        // },
    ];

    if(permission?.edit_access){
        tableColumns.push(
            {
                name: "Action",
                selector: (row) => row["action"],
                sortable: false,
                center: true,
            },
        )
    }

    const handleDelete = async () => {
        const result = await SweetAlert.fire({
            title: "Are you sure you want to delete?",
            cancelButtonText: "No!",
            confirmButtonText: "Yes!",
            reverseButtons: true,
            showCancelButton: true,
        });

        if (result.isConfirmed) {
            try {
                const selectedIds = selectedRows.map((row) => row.id);
                await Promise.all(selectedIds.map((id) => DeletePatient(id)));
                setSelectedRows([]);
                toast.success("Deleted Successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                fetchPatient();
            } catch (error) {
                toast.error("An error occurred!", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
    };

    const fetchPatient = async () => {
        const response = await PatientList();
        if (response.status === true) {
            let filteredAppointments;
            
            if (roleId === '4') {
                // const mapID = response['data'].map((id) => id.id)
                filteredAppointments = response['data'].filter((patient) => patient.id === userId
            );
        } else if (roleId === '1' || roleId === '2' || roleId === '3' || roleId === '5') {
            filteredAppointments = response['data']
        }
        // setPatient(response.data);
        setPatient(filteredAppointments);
        }
    };

    useEffect(() => {
        fetchPatient();
    }, []);
    return (
        <Suspense fallback={<Loader />}>
            <Card>
                <Breadcrumbs mainTitle="Patient" parent="Dashboard" title="patient" />
                <CardHeader className="card-no-border">
                    <div className="header-top">
                        <Fragment>
                            <div className="search">
                                <Form className="theme-form">
                                    <FormGroup className="form-group">
                                        <div className="input-group">
                                            <Input
                                                className="form-control"
                                                type="text"
                                                placeholder="search"
                                                value={searchKeyword}
                                                onChange={(e) => handleSearchKeyword(e.target.value)}
                                            />
                                            <div className="input-group-append">
                                                <span
                                                    className="input-group-text"
                                                    onClick={() => clearSearchTab()}
                                                >
                                                    <i className="fa fa-times" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Form>
                            </div>
                        </Fragment>
                        {permission?.create_access && <div className="card-header-right-icon">
                            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
                            <div className="card-header-right-icon">
                                <Btn
                                    attrBtn={{
                                        color: "light-primary",
                                        className: "btn badge-light-primary",
                                        onClick: () =>
                                            navigate(`${process.env.PUBLIC_URL}/patientform/:layout`),
                                    }}
                                >
                                    + Add Patient
                                </Btn>
                            </div>
                        </div>}
                    </div>
                </CardHeader>
                <CardBody className="pt-0 campaign-table">
                    <div className="recent-table table-responsive currency-table">
                        <Fragment>
                            {selectedRows.length !== 0 && (
                                <div
                                    className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
                                >
                                    <H4 attrH4={{ className: "text-muted m-0" }}>
                                        Delet Selected Data..!
                                    </H4>
                                    <Btn
                                        attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                                    >
                                        Delete
                                    </Btn>
                                </div>
                            )}
                            <DataTable
                                data={dummytabledata}
                                columns={tableColumns}
                                striped={true}
                                center={true}
                                pagination
                                selectableRows = {permission?.delete_acccess}
                                onSelectedRowsChange={handleRowSelected}
                                clearSelectedRows={toggleDelet}
                            />
                        </Fragment>
                        {/* <Table>
            <thead>
              <tr>
                {PatientList.header.map((item, i) => (
                  <th key={i} className='f-light'>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {PatientList.body.map((item, i) => (
                <tr key={i}>
                  <td className={`border-icon ${item.ADPlatform}`}>
                    <div>
                      <div className='social-circle'>
                    {item.index}
                      </div>
                    </div>
                  </td>
                  <td>{item.PatientName}</td>
                  <td>{item.RegNo}</td>
                  <td>
                    <div className='change-currency'>
                    
                      {item.Gender}
                    </div>
                  </td>
                  <td>{item.ContactNumber}</td>
                  <td>
                    {item.CreatedDate}
                  </td>
                  <td>
                    {item.Action}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table> */}
                    </div>
                </CardBody>
            </Card>
        </Suspense>
    );
};

export default PatientView;
